import permissions from '../permission-list'

export default [
  {
    path: '/v2/categories',
    name: 'categories-v2',
    component: () => import('@/views/v2/Categories.vue'),
    meta: {
      pageTitle: 'Daftar Kategori',
      resource: permissions.categoryV2,
      action: 'read',
      navActiveLink: 'categories-v2',
      localstorage: {
        query: 'categories-v2-query',
      },
      breadcrumb: [
        {
          text: 'Kategori',
          active: true,
        },
      ],
    },
  },
  {
    path: '/v2/categories/create',
    name: 'categories-v2-create',
    component: () => import('@/views/v2/CategoryCreate.vue'),
    meta: {
      pageTitle: 'Buat Kategori',
      resource: permissions.categoryV2,
      action: 'manage',
      navActiveLink: 'categories-v2',
      breadcrumb: [
        { text: 'Kategori', to: { name: 'categories-v2' } },
        { text: 'Buat', active: true },
      ],
    },
  },
  {
    path: '/v2/categories/:id/edit',
    name: 'categories-v2-edit',
    component: () => import('@/views/v2/CategoryEdit.vue'),
    meta: {
      pageTitle: 'Edit Kategori',
      resource: permissions.categoryV2,
      action: 'manage',
      navActiveLink: 'categories-v2',
      breadcrumb: [
        { text: 'Kategori', to: { name: 'categories-v2' } },
        { text: 'Edit', active: true },
      ],
    },
  },
  {
    path: '/v2/categories/:id/detail',
    name: 'categories-v2-detail',
    component: () => import('@/views/v2/CategoryDetail.vue'),
    meta: {
      pageTitle: 'Detail Kategori',
      resource: permissions.categoryV2,
      action: 'read',
      navActiveLink: 'categories-v2',
      breadcrumb: [
        { text: 'Kategori', to: { name: 'categories-v2' } },
        { text: 'Detail', active: true },
      ],
    },
  },
]
